import * as React from 'react';
import Button from '../../../../common/form/Button';
import { removeRemoteLockIntegration } from '../../../../../api/PropertyIntegration';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    remoteLockGroupName?: string;
    propertyId: number;
    reload: () => Promise<void>;
}

const handleLockConnect = (propertyId: number) =>
    (location.href = `https://connect.remotelock.com/oauth/authorize?client_id=${
        process.env.REACT_APP_REMOTE_LOCK_CLIENT_ID
    }&response_type=code&redirect_uri=https://${
        location.hostname === 'localhost'
            ? 'tour24-ui-development.azurewebsites.net'
            : location.host
    }/confirmlock?state=${propertyId}`);

const RemoteLockConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <div className="row">
        <div className="col">
            <div className="access-integration-buttons">
                <Button
                    addlClassName="btn-primary"
                    type="button"
                    text={props.remoteLockGroupName ? 'Change RemoteLock' : 'Configure RemoteLock'}
                    onClick={
                        props.remoteLockGroupName
                            ? () => {
                                  if (
                                      window.confirm(
                                          'Please check for upcoming tours. Changing the RemoteLock' +
                                              ' will affect upcoming tours.'
                                      )
                                  ) {
                                      handleLockConnect(props.propertyId);
                                  }
                              }
                            : () => handleLockConnect(props.propertyId)
                    }
                    disabled={isUser} 
                />
                {props.remoteLockGroupName ? (
                    <div style={{ marginLeft: '5px' }}>
                        <Button
                            text={'Remove'}
                            addlClassName="btn-danger"
                            onClick={async () => {
                                var removeResult = await removeRemoteLockIntegration(
                                    props.propertyId
                                );
                                if (removeResult.success) {
                                    props.reload();
                                }
                            }}
                        />
                    </div>
                ) : null}
            </div>
        </div>

        {props.remoteLockGroupName && (
            <div className="col">
                <b>Current RemoteLock Configuration:</b> {props.remoteLockGroupName}
            </div>
        )}
    </div>
);
};
export default RemoteLockConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/RemoteLockConfigurationSection.tsx